module.exports = __webpack_public_path__ + "27c5e02f50396d71d83459945007fe8a.pdf";